<template>
  <v-alert
    outlined
    :color="color"
    :class="[
      'docs-callout mb-4',
      { 'docs-callout--dark': isDarkDocsTheme },
    ]"
  >
    <div class="d-flex align-start">
      <font-awesome-icon
        v-if="icon"
        :icon="icon"
        size="sm"
        class="mr-2 mt-1"
      />

      <div>
        <div class="subtitle-2 font-weight-bold mb-1">
          {{ title }}
        </div>

        <div class="body-2">
          <slot />
        </div>
      </div>
    </div>
  </v-alert>
</template>

<script>
import themeClasses from '@/mixins/themeClasses'

export default {
  name: 'DocsCallout',
  mixins: [themeClasses],
  props: {
    title: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'info',
    },
    icon: {
      type: Array,
      default: () => ['fas', 'info-circle'],
    },
  },
  computed: {
    isDarkDocsTheme() {
      return this.isDarkThemeContext()
    },
  },
}
</script>

<style scoped lang="scss">
.docs-callout {
  border-radius: 10px;
}

.docs-callout--dark {
  border-color: rgba(150, 214, 255, 0.34) !important;
  background-color: rgba(8, 23, 37, 0.66);
  color: rgba(234, 246, 255, 0.92) !important;
}

.docs-callout--dark ::v-deep .v-alert__content {
  color: inherit;
}
</style>
